const REACT_APP_BFF_URL = process.env.REACT_APP_BFF_URL;

export function base64ToBlob(base64String) {
    // "data:TYPE;base64,AAAA..."
    const [meta, data] = base64String.split(',');
    const mime = meta.match(/:(.*?);/)[1];
    const binary = atob(data);
    const array = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        array[i] = binary.charCodeAt(i);
    }
    return new Blob([array], {type: mime});
}

export const createUser = async (email, givenName, familyName, profilePicture, token) => {
    const response = await fetch(`${REACT_APP_BFF_URL}/users`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
            email: email,
            given_name: givenName,
            family_name: familyName,
            profile_picture: profilePicture
        })
    });
    return response.json();
};

export const getMyUser = async (token) => {
    const response = await fetch(`${REACT_APP_BFF_URL}/users/me`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Error occurred while fetching user.');
    }

    const data = await response.json();
    return data;
};

export const getUsers = async (token) => {
    const response = await fetch(`${REACT_APP_BFF_URL}/users`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Error occurred while fetching users.');
    }

    const data = await response.json();
    return data;
};

export const toggle_active_user = async (token, uid) => {
    const response = await fetch(`${REACT_APP_BFF_URL}/users/${uid}/activate`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Error occurred while fetching user.');
    }

    const data = await response.json();
    return data;
};

export const updateUserProfileFinish = async (token, profileData) => {
    const {phoneNumber, displayName, license, signature} = profileData;

    const formData = new FormData();
    formData.append("phone_number", phoneNumber);
    formData.append("display_name", displayName);
    formData.append("license", license);

    if (signature) {
        const blob = base64ToBlob(signature);
        const mime = blob.type.split("/")[1]; // "png" o "jpeg"
        formData.append("signature", blob, `signature.${mime}`);
    }

    const res = await fetch(
        `${process.env.REACT_APP_BFF_URL}/users/me/finish-profile`,
        {
            method: 'PUT',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        }
    );

    if (!res.ok) {
        const err = await res.json();
        throw new Error(err.detail || 'Error updating profile');
    }
    return res.json();
};

export const chooseVeterinary = async (token, veterinaryId) => {
    const res = await fetch(
        `${process.env.REACT_APP_BFF_URL}/users/choose-veterinary/${veterinaryId}`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({}),
        }
    );

    if (!res.ok) {
        const err = await res.json();
        throw new Error(err.detail || 'Error choosing veterinary');
    }

    return res.json();
};